/* import __COLOCATED_TEMPLATE__ from './lsg-block-button.hbs'; */
import { equal } from '@ember/object/computed';
import { computed } from '@ember/object';
import Component from '@ember/component';

/**
 * Potential background types for the block button.
 *
 * @type {Object}
 */
export const LSG_BLOCK_BUTTON__BACKGROUND_TYPE = {
  TRANSPARENT: 'transparent',
  WHITE: 'white'
};

/**
 * This is a button component like what is used for the in the Posting Creation workflow.  It will
 * have an icon and some text and will highlight when selected.
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['LSG-c-block-button'],
  classNameBindings: [
    '_isBackgroundTypeWhite:LSG-c-block-button--background-type--white',
    'isDisabled:LSG-c-block-button--disabled',
    'isHasError:LSG-c-block-button--error',
    'isSelected:LSG-c-block-button--selected'
  ],

  /**************************
   * REQUIRED PARAMS
   **************************/

  /**
   * @param {String|Array<String>}      Materialize icon name or an Array of icon names for multiple
   */
  materializeIconName: '',

  /**
   * @param {Function}    This will be called when this button is selected with the passed in value.
   */
  onSelected: function(value) {},

  /**
   * @param {String}      Title of the button
   */
  title: '',

  /**
   * @param {String}      The value that will be passed back when this button is selected.
   */
  value: '',

  /**************************
   * OPTIONAL PARAMS
   **************************/

  /**
   * The background type for the block button.
   *
   * @param {String}      of type LSG_BLOCK_BUTTON__BACKGROUND_TYPE.*
   */
  backgroundType: LSG_BLOCK_BUTTON__BACKGROUND_TYPE.TRANSPARENT,

  /**
   * @param {Boolean=}    True if this component should be disabled.
   */
  isDisabled: false,

  /**
   * @param {Boolean=}    True when this component should show the error format.
   */
  isHasError: false,

  /**
   * @param {Boolean=}    If this is in the selected mode or not
   */
  isSelected: false,

  /**************************
   * COMPONENT LIFE-CYCLE FUNCTIONS
   **************************/

  /**
   * @inheritDoc
   */
  click() {
    this.get('onSelected')(this.get('value'));
  },

  /**************************
   * PRIVATE
   **************************/

  /**
   * @type {Ember.MutableArray<String>}   All the icon names to render out.
   */
  _materializeIcons: computed('materializeIconName', function() {
    let materializeIcons = this.get('materializeIconName');
    if (!materializeIcons) {
      return [];
    }

    return Array.isArray(materializeIcons) ? materializeIcons : [materializeIcons];
  }),

  /**
   * @type {Boolean}      True if the background type is white.
   */
  _isBackgroundTypeWhite: equal('backgroundType', LSG_BLOCK_BUTTON__BACKGROUND_TYPE.WHITE)
});
